import React from 'react';
import { cn } from '../../lib/utils';

export function Select({ className, children, value, onValueChange, ...props }) {
  return (
    <select
      value={value}
      onChange={(e) => onValueChange && onValueChange(e.target.value)}
      className={cn(
        "px-3 py-2 rounded-lg border border-border bg-input text-sm text-foreground",
        "outline-none focus:ring-2 focus:ring-primary/40 cursor-pointer",
        className
      )}
      {...props}
    >
      {children}
    </select>
  );
}

export function SelectTrigger({ className, children, ...props }) {
  // When used in compound pattern, render as a wrapper div
  return (
    <div className={cn("relative", className)} {...props}>
      {children}
    </div>
  );
}

export function SelectValue({ placeholder }) {
  return <span className="text-muted-foreground">{placeholder}</span>;
}

export function SelectContent({ children }) {
  return <>{children}</>;
}

export function SelectItem({ value, children }) {
  return <option value={value}>{children}</option>;
}
